import { ChatPage } from "@/features/chat/pages/Chat";
import { FC } from "react";

type TChatLayoutProps = {
  isCompany?: boolean;
};

export const Chat: FC<TChatLayoutProps> = ({ isCompany = false }) => {
  return <ChatPage isCompany={isCompany} />;
};

export default Chat;
